import { useQuery } from '@tanstack/react-query';
import { Navigate, Route } from 'react-router-dom';
import { Routes } from '@datadog/browser-rum-react/react-router-v6';

import { listAudits } from './api';
import { AuditDetail } from './pages/AuditDetail';
import { AuditDiffView } from './pages/AuditDiffView';
import { AuditLayout } from './pages/AuditLayout';
import { EmptyAuditState } from './pages/EmptyAuditState';
import { useAuditBasePath } from './utils/useAuditBasePath';

import './styles/app.scss';

// Landing route: drop the reviewer straight onto the most recent audit rather than an empty state,
// since this preview always ships with bundled audits.
const AuditIndexRedirect = () => {
  const base = useAuditBasePath();
  const { data } = useQuery({ queryKey: ['audits'], queryFn: listAudits });
  if (!data || data.length === 0) return <EmptyAuditState />;
  return <Navigate to={`${base}/${data[0].id}`} replace />;
};

// Entry point registered as the `paid-search-audit` location's pageComponent. The app mounts under
// `/:company/paid-search-audit/*`; these nested routes match the remainder of the path. AuditLayout
// is the layout route (left-rail history + <Outlet/>); the children render into it.
export const PaidSearchAudit = () => (
  <Routes>
    <Route element={<AuditLayout />}>
      <Route index element={<AuditIndexRedirect />} />
      <Route path=':auditId' element={<AuditDetail />} />
      <Route path=':auditId/diff' element={<AuditDiffView />} />
    </Route>
  </Routes>
);
